class ImageEditor {
  constructor($scope, $uibModal) {
    'ngInject';

    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.areaMinSize = 120;
    this.uploadIcon = require('./img/upload.svg');
  }

  async $onInit() {
    this.file = undefined;
    this.myImage = '';
    this.myCroppedImage = '';
    angular.element(document.querySelector('#fileInput')).on('change', this.handleFileSelect.bind(this));
  }

  uploadClicked() {
    angular.element(document.querySelector('#fileInput')).click();
  }

  handleFileSelect(event) {
    this.file = event.currentTarget.files[0];
    if (!this.file) {
      return;
    }
    if (!/\.(jpe?g|png)$/i.test(this.file.name)) {
      this.$scope.$emit('onInvalidTypeNotification');
      return;
    }
    const reader = new FileReader();
    reader.onload = (evt) => {
      const i = new Image();
      i.onload = () => {
        console.log('original image ', i.width, 'x', i.height, ' length', evt.target.result.length);
        if (i.width < this.resolve.requiredWidth || i.height < this.resolve.requiredHeight) {
          this.$scope.$emit('onInvalidSizeNotification', { width: i.width, height: i.height, requiredWidth: this.resolve.requiredWidth, requiredHeight: this.resolve.requiredHeight });
          return;
        }
        this.$scope.$apply(() => {
          this.myImage = evt.target.result;
          const maximum = i.width > i.height ? i.width : i.height;
          const minSize = Math.ceil(this.resolve.requiredWidth / maximum * 300);
          this.areaMinSize = minSize < 60 ? 60 : minSize;
        });
      };
      i.src = evt.target.result;
    };
    reader.readAsDataURL(this.file);
  }

  async save() {
    this.close({ $value: {
      file: this.file,
      original: this.myCroppedImage
    } });
  }

  removeCurrentProfilePicture() {
    const confirmDeleteProfilePicture = this.createConfirmationModal('Ben je zeker dat je jouw profielfoto wilt verwijderen?');

    confirmDeleteProfilePicture.result.then(result => {
      this.$scope.$emit('onImageDelete');
      this.resolve.currentProfilePicture = null;
    }, err => {});
  }

  createConfirmationModal(question) {
    return this.$uibModal.open({
      animation: true,
      component: 'myConfirmModal',
      size: 'md',
      backdrop: 'static',
      resolve: {
        confirmationQuestion: () => question,
        icon: () => require('./img/delete.svg'),
        title: () => 'Verwijder profielfoto'
      }
    });
  }

  cancel() {
    this.dismiss({ $value: 'cancel' });
  }
}

module.exports = {
  template: require('./kovImageEditor.html'),
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controllerAs: 'ctrl',
  controller: ImageEditor
};
